module.exports = __webpack_public_path__ + "img/hgbzxxyfg.afa528fc.png";